module.exports = __webpack_public_path__ + "static/tild3139-6535-4361-b363-326635353530__4_forbes-55ab8ae2caa4db5301b7b0aaa94ab750.jpg";